// src/pages/ProfesseurDetail.js - VERSION RICH UI cohérente avec Professeurs.js
import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import axios from 'axios';
import { CalendarPlus, FileText, Target, Globe, Video, MessageCircle, BarChart3, MapPin, Award, Clock } from 'lucide-react';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Marcellus&family=DM+Sans:wght@300;400;500;600&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  .prof-detail-page {
    min-height: 100vh;
    background: #f7f4ef;
    font-family: 'DM Sans', sans-serif;
    color: #1a1a1a;
  }

  /* ── NAV ── */
  .detail-nav {
    background: #fff;
    border-bottom: 1px solid #e8e2d9;
    padding: 14px 40px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #aaa;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  }
  .detail-nav a {
    color: #0b1f17;
    text-decoration: none;
    font-weight: 600;
    transition: color 0.2s;
  }
  .detail-nav a:hover { color: #d4a359; }
  .nav-sep { color: #ddd; }

  /* ── HERO PROF ── */
  .prof-hero {
    background: linear-gradient(135deg, #0b1f17 0%, #0f3d3d 100%);
    padding: 48px 40px;
    position: relative;
    overflow: hidden;
  }
  .prof-hero::before {
    content: '';
    position: absolute;
    top: -80px; right: -80px;
    width: 400px; height: 400px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(212,163,89,0.15) 0%, transparent 70%);
    pointer-events: none;
  }
  .prof-hero::after {
    content: 'م';
    position: absolute;
    bottom: -30px; left: 20px;
    font-size: 180px;
    color: rgba(255,255,255,0.03);
    font-family: 'Marcellus', serif;
    pointer-events: none;
    line-height: 1;
  }
  .prof-hero-inner {
    max-width: 1100px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 32px;
    align-items: center;
    position: relative;
    z-index: 1;
  }

  /* Avatar */
  .prof-avatar-wrap {
    position: relative;
    flex-shrink: 0;
  }
  .prof-avatar {
    width: 100px; height: 100px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid rgba(212,163,89,0.5);
    display: block;
  }
  .prof-avatar-placeholder {
    width: 100px; height: 100px;
    border-radius: 50%;
    background: rgba(255,255,255,0.1);
    border: 3px solid rgba(212,163,89,0.4);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .prof-initials {
    font-family: 'Marcellus', serif;
    font-size: 32px;
    font-weight: 700;
    color: #fff;
  }
  .online-badge-hero {
    position: absolute;
    bottom: 4px; right: 4px;
    width: 20px; height: 20px;
    background: #27ae60;
    border-radius: 50%;
    border: 3px solid #0b1f17;
    box-shadow: 0 0 0 3px rgba(39,174,96,0.3);
    animation: pulse 2s infinite;
  }
  @keyframes pulse {
    0%,100% { box-shadow: 0 0 0 3px rgba(39,174,96,0.3); }
    50% { box-shadow: 0 0 0 7px rgba(39,174,96,0.08); }
  }

  /* Info hero */
  .prof-hero-info {}
  .prof-hero-name {
    font-family: 'Marcellus', serif;
    font-size: clamp(24px, 3vw, 36px);
    font-weight: 700;
    color: #fff;
    margin-bottom: 6px;
    line-height: 1.15;
  }
  .prof-hero-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
  }
  .meta-chip {
    display: flex;
    align-items: center;
    gap: 5px;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.12);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    color: rgba(255,255,255,0.75);
  }
  .meta-chip.online-chip {
    background: rgba(39,174,96,0.2);
    border-color: rgba(39,174,96,0.4);
    color: #6eed8e;
  }
  .prof-hero-rating {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
  .stars-hero { display: flex; gap: 2px; }
  .star-h { font-size: 16px; color: rgba(255,255,255,0.2); }
  .star-h.filled { color: #f39c12; }
  .rating-big {
    font-family: 'Marcellus', serif;
    font-size: 22px;
    font-weight: 700;
    color: #fff;
  }
  .rating-count-h {
    font-size: 13px;
    color: rgba(255,255,255,0.5);
  }
  .sub-ratings {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    margin-top: 10px;
  }
  .sub-rating-item {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  .sub-label {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgba(255,255,255,0.4);
  }
  .sub-val {
    font-size: 13px;
    font-weight: 600;
    color: rgba(255,255,255,0.85);
  }

  /* CTA hero */
  .prof-hero-cta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 12px;
  }
  .price-hero-block {
    text-align: right;
  }
  .price-hero-main {
    font-family: 'Marcellus', serif;
    font-size: 32px;
    font-weight: 700;
    color: #d4a359;
    line-height: 1;
  }
  .price-hero-sub {
    font-size: 12px;
    color: rgba(255,255,255,0.4);
    margin-top: 2px;
  }
  .price-hero-alt {
    font-size: 12px;
    color: rgba(255,255,255,0.35);
    margin-top: 3px;
  }
  .btn-book-hero {
    padding: 14px 28px;
    background: #d4a359;
    color: #fff;
    border: none;
    border-radius: 12px;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: background 0.2s, transform 0.15s;
    white-space: nowrap;
    box-shadow: 0 4px 16px rgba(212,163,89,0.35);
  }
  .btn-book-hero:hover { background: #c49348; transform: translateY(-2px); }

  /* ── MAIN CONTENT ── */
  .detail-content {
    max-width: 1100px;
    margin: 0 auto;
    padding: 36px 40px;
    display: grid;
    grid-template-columns: 1fr 380px;
    gap: 28px;
    align-items: start;
  }

  /* ── SECTIONS ── */
  .detail-section {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e8e2d9;
    padding: 28px;
    margin-bottom: 20px;
  }
  .section-title {
    font-family: 'Marcellus', serif;
    font-size: 18px;
    font-weight: 700;
    color: #0b1f17;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .section-title-line {
    flex: 1;
    height: 1px;
    background: #f0ebe2;
  }

  /* Bio */
  .bio-text {
    font-size: 14px;
    line-height: 1.8;
    color: #555;
  }

  /* Tags */
  .tags-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .tag-spec {
    padding: 6px 14px;
    background: #f0ebe2;
    color: #5a4a3a;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
  }
  .tag-lang {
    padding: 6px 14px;
    background: #e8f0fe;
    color: #1a56bb;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
  }

  /* Vidéo */
  .video-wrap {
    border-radius: 12px;
    overflow: hidden;
    background: #000;
  }
  .video-wrap video { display: block; width: 100%; }

  /* ── AVIS ── */
  .review-card {
    padding: 18px 0;
    border-bottom: 1px solid #f0ebe2;
  }
  .review-card:last-child { border-bottom: none; }
  .review-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 10px;
    gap: 12px;
  }
  .reviewer-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .reviewer-av {
    width: 36px; height: 36px;
    border-radius: 50%;
    background: linear-gradient(135deg, #0b1f17, #0f3d3d);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    flex-shrink: 0;
  }
  .reviewer-name {
    font-size: 13px;
    font-weight: 600;
    color: #1a1a1a;
  }
  .review-date {
    font-size: 11px;
    color: #bbb;
    margin-top: 1px;
  }
  .stars-review { display: flex; gap: 1px; }
  .star-r { font-size: 13px; color: #e0d9ce; }
  .star-r.filled { color: #f39c12; }
  .review-comment {
    font-size: 13px;
    line-height: 1.6;
    color: #555;
    font-style: italic;
    margin-bottom: 8px;
  }
  .review-sub-ratings {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  .sub-r-chip {
    background: #f7f4ef;
    padding: 3px 10px;
    border-radius: 6px;
    font-size: 11px;
    color: #888;
  }
  .btn-more-reviews {
    width: 100%;
    margin-top: 16px;
    padding: 12px;
    background: transparent;
    border: 1.5px solid #e0d9ce;
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #0b1f17;
    cursor: pointer;
    transition: all 0.2s;
  }
  .btn-more-reviews:hover { background: #0b1f17; color: #fff; border-color: #0b1f17; }
  .no-reviews-box {
    text-align: center;
    padding: 32px 20px;
    color: #bbb;
  }
  .no-reviews-box .icon { font-size: 36px; margin-bottom: 10px; opacity: 0.4; }

  /* ── SIDEBAR STICKY ── */
  .detail-sidebar {
    position: sticky;
    top: 60px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .sidebar-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e8e2d9;
    overflow: hidden;
  }
  .sidebar-card-header {
    background: linear-gradient(135deg, #0b1f17 0%, #0f3d3d 100%);
    padding: 20px;
  }
  .sidebar-price-main {
    font-family: 'Marcellus', serif;
    font-size: 36px;
    font-weight: 700;
    color: #d4a359;
    line-height: 1;
  }
  .sidebar-price-sub {
    font-size: 12px;
    color: rgba(255,255,255,0.45);
    margin-top: 3px;
  }
  .sidebar-price-alt {
    font-size: 13px;
    color: rgba(255,255,255,0.35);
    margin-top: 6px;
    padding-top: 10px;
    border-top: 1px solid rgba(255,255,255,0.08);
  }
  .sidebar-card-body {
    padding: 20px;
  }
  .btn-book-sidebar {
    display: block;
    width: 100%;
    padding: 15px;
    background: #d4a359;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    text-decoration: none;
    text-align: center;
    margin-bottom: 12px;
    transition: background 0.2s, transform 0.15s;
    box-shadow: 0 4px 16px rgba(212,163,89,0.3);
  }
  .btn-book-sidebar:hover { background: #c49348; transform: translateY(-1px); }
  .sidebar-guarantee {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: #aaa;
    justify-content: center;
  }

  /* Stats card */
  .stats-card { padding: 20px; }
  .stat-row-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #f0ebe2;
  }
  .stat-row-card:last-child { border-bottom: none; }
  .stat-row-label {
    font-size: 12px;
    color: #888;
    font-weight: 500;
  }
  .stat-row-val {
    font-size: 13px;
    font-weight: 700;
    color: #0b1f17;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .mini-stars { display: flex; gap: 1px; }
  .mini-star { font-size: 10px; color: #e0d9ce; }
  .mini-star.filled { color: #f39c12; }

  /* ── LOADING ── */
  .loading-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    gap: 16px;
  }
  .spinner-ring {
    width: 44px; height: 44px;
    border: 3px solid #e0d9ce;
    border-top-color: #0b1f17;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* ── BOTTOM CTA (mobile) ── */
  .bottom-cta-bar {
    display: none;
    position: fixed;
    bottom: 0; left: 0; right: 0;
    background: #fff;
    border-top: 1px solid #e8e2d9;
    padding: 14px 20px;
    z-index: 200;
    box-shadow: 0 -4px 20px rgba(0,0,0,0.08);
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .bottom-cta-price {
    font-family: 'Marcellus', serif;
    font-size: 22px;
    font-weight: 700;
    color: #0b1f17;
  }
  .bottom-cta-sub { font-size: 11px; color: #aaa; }
  .btn-book-bottom {
    padding: 12px 24px;
    background: #d4a359;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;
    box-shadow: 0 4px 14px rgba(212,163,89,0.3);
  }

  /* ── RESPONSIVE ── */
  @media (max-width: 900px) {
    .prof-hero { padding: 32px 20px; }
    .prof-hero-inner {
      grid-template-columns: auto 1fr;
      grid-template-rows: auto auto;
    }
    .prof-hero-cta {
      grid-column: 1 / -1;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    .price-hero-block { text-align: left; }
    .detail-nav { padding: 12px 20px; }
    .detail-content {
      grid-template-columns: 1fr;
      padding: 20px;
    }
    .detail-sidebar { position: static; }
    .bottom-cta-bar { display: flex; }
  }
`;

// ── helpers ──────────────────────────────────────────────
const getInitials = (nom = '') => {
  const parts = nom.trim().split(' ');
  return parts.length >= 2
    ? (parts[0][0] + parts[1][0]).toUpperCase()
    : nom.slice(0, 2).toUpperCase();
};

const getLastSeen = (ts) => {
  if (!ts) return null;
  const diff = Math.round((Date.now() - new Date(ts)) / 60000);
  if (diff < 5) return 'En ligne maintenant';
  if (diff < 60) return `Il y a ${diff} min`;
  if (diff < 1440) return `Il y a ${Math.round(diff / 60)}h`;
  return `Il y a ${Math.round(diff / 1440)}j`;
};

const formatDate = (d) => new Date(d).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });

const Stars = ({ rating = 0, size = 'r' }) => {
  const cls = size === 'h' ? 'star-h' : 'star-r';
  return (
    <div className={size === 'h' ? 'stars-hero' : 'stars-review'}>
      {[1,2,3,4,5].map(i => (
        <span key={i} className={`${cls} ${i <= Math.round(rating) ? 'filled' : ''}`}>★</span>
      ))}
    </div>
  );
};

const MiniStars = ({ rating = 0 }) => (
  <div className="mini-stars">
    {[1,2,3,4,5].map(i => (
      <span key={i} className={`mini-star ${i <= Math.round(rating) ? 'filled' : ''}`}>★</span>
    ))}
  </div>
);

// ── composant ────────────────────────────────────────────
export default function ProfesseurDetail() {
  const { id } = useParams();
  const [professor, setProfessor] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reviewsPage, setReviewsPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [token, setToken] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session) { setError('Veuillez vous connecter'); return; }
        setToken(session.access_token);

        const res = await axios.get(`${process.env.REACT_APP_API_URL}/profs`, {
          headers: { Authorization: `Bearer ${session.access_token}` }
        });
        if (res.data.success) {
          const found = res.data.profs.find(p => p.id === id);
          if (!found) { setError('Professeur non trouvé'); return; }
          setProfessor(found);
        }

        try {
          const rev = await axios.get(`${process.env.REACT_APP_API_URL}/reviews/prof/${id}?limit=10&offset=0`, {
            headers: { Authorization: `Bearer ${session.access_token}` }
          });
          if (rev.data.success) {
            setReviews(rev.data.reviews);
            setStats(rev.data.stats);
            setHasMore(rev.data.pagination?.has_more || false);
          }
        } catch {}
      } catch {
        setError('Erreur lors du chargement du profil');
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const loadMore = async () => {
    try {
      const next = reviewsPage + 1;
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/reviews/prof/${id}?limit=10&offset=${next * 10}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.success && res.data.reviews.length > 0) {
        setReviews(prev => [...prev, ...res.data.reviews]);
        setReviewsPage(next);
        setHasMore(res.data.pagination?.has_more || false);
      } else setHasMore(false);
    } catch {}
  };

  if (loading) return (
    <div className="prof-detail-page">
      <style>{styles}</style>
      <div className="loading-wrap">
        <div className="spinner-ring" />
        <span style={{ color: '#999', fontSize: 14 }}>Chargement du profil…</span>
      </div>
    </div>
  );

  if (error || !professor) return (
    <div className="prof-detail-page">
      <style>{styles}</style>
      <div className="loading-wrap">
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>❌</div>
          <p style={{ color: '#666', marginBottom: 16 }}>{error || 'Professeur non trouvé'}</p>
          <Link to="/professeurs" style={{ color: '#0b1f17', fontWeight: 600 }}>← Retour aux professeurs</Link>
        </div>
      </div>
    </div>
  );

  const nom = professor.prenom ? `${professor.prenom} ${professor.nom}` : professor.nom;
  const isOnline = professor.disponible_maintenant || professor.is_online;
  const lastSeen = getLastSeen(professor.derniere_connexion);

  return (
    <div className="prof-detail-page">
      <style>{styles}</style>

      {/* NAV */}
      <div className="detail-nav">
        <Link to="/professeurs">Professeurs</Link>
        <span className="nav-sep">›</span>
        <span>{nom}</span>
      </div>

      {/* HERO */}
      <div className="prof-hero">
        <div className="prof-hero-inner">

          {/* Avatar */}
          <div className="prof-avatar-wrap">
            {professor.photo_url ? (
              <img className="prof-avatar" src={professor.photo_url} alt={nom} />
            ) : (
              <div className="prof-avatar-placeholder">
                <span className="prof-initials">{getInitials(professor.nom)}</span>
              </div>
            )}
            {isOnline && <div className="online-badge-hero" />}
          </div>

          {/* Info */}
          <div className="prof-hero-info">
            <h1 className="prof-hero-name">{nom}</h1>
            <div className="prof-hero-meta">
              {professor.pays_origine && (
                <span className="meta-chip"><MapPin size={14} style={{ verticalAlign: -2, marginRight: 4 }} />{professor.pays_origine}</span>
              )}
              {professor.experience_annees && (
                <span className="meta-chip"><Award size={14} style={{ verticalAlign: -2, marginRight: 4 }} />{professor.experience_annees}+ ans</span>
              )}
              {isOnline ? (
                <span className="meta-chip online-chip">🟢 En ligne maintenant</span>
              ) : lastSeen ? (
                <span className="meta-chip"><Clock size={14} style={{ verticalAlign: -2, marginRight: 4 }} />{lastSeen}</span>
              ) : null}
              {professor.video_intro_url && (
                <span className="meta-chip"><Video size={14} style={{ verticalAlign: -2, marginRight: 4 }} />Vidéo intro</span>
              )}
            </div>
            <div className="prof-hero-rating">
              <Stars rating={professor.rating_moyen || 0} size="h" />
              <span className="rating-big">{(professor.rating_moyen || 0).toFixed(1)}</span>
              <span className="rating-count-h">{professor.nombre_avis || 0} avis</span>
            </div>
            {stats && (
              <div className="sub-ratings">
                {stats.rating_pedagogie > 0 && (
                  <div className="sub-rating-item">
                    <span className="sub-label">Pédagogie</span>
                    <span className="sub-val">★ {stats.rating_pedagogie?.toFixed(1)}</span>
                  </div>
                )}
                {stats.rating_communication > 0 && (
                  <div className="sub-rating-item">
                    <span className="sub-label">Communication</span>
                    <span className="sub-val">★ {stats.rating_communication?.toFixed(1)}</span>
                  </div>
                )}
                {stats.rating_ponctualite > 0 && (
                  <div className="sub-rating-item">
                    <span className="sub-label">Ponctualité</span>
                    <span className="sub-val">★ {stats.rating_ponctualite?.toFixed(1)}</span>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* CTA hero (desktop) */}
          <div className="prof-hero-cta">
            {/* Prix masqué - tarif fixe FirstArabic */}
            <Link to={`/reservation?prof_id=${professor.id}`} className="btn-book-hero">
              <CalendarPlus size={18} style={{ verticalAlign: -3, marginRight: 8 }} />Réserver un cours
            </Link>
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="detail-content">

        {/* GAUCHE */}
        <div>

          {/* Bio */}
          {professor.bio && (
            <div className="detail-section">
              <div className="section-title">
                <FileText size={18} style={{ verticalAlign: -3, marginRight: 8 }} />À propos
                <div className="section-title-line" />
              </div>
              <p className="bio-text">{professor.bio}</p>
            </div>
          )}

          {/* Spécialités + Langues */}
          <div className="detail-section">
            <div className="section-title">
              <Target size={18} style={{ verticalAlign: -3, marginRight: 8 }} />Spécialités
              <div className="section-title-line" />
            </div>
            <div className="tags-wrap" style={{ marginBottom: 20 }}>
              {(professor.specialites || [professor.specialite]).filter(Boolean).map((s, i) => (
                <span key={i} className="tag-spec">{s}</span>
              ))}
            </div>
            <div className="section-title">
              <Globe size={18} style={{ verticalAlign: -3, marginRight: 8 }} />Langues
              <div className="section-title-line" />
            </div>
            <div className="tags-wrap">
              {(professor.langues_parlees || ['Arabe']).map((l, i) => (
                <span key={i} className="tag-lang">{l}</span>
              ))}
            </div>
          </div>

          {/* Vidéo */}
          {professor.video_intro_url && (
            <div className="detail-section">
              <div className="section-title">
                <Video size={18} style={{ verticalAlign: -3, marginRight: 8 }} />Vidéo d'introduction
                <div className="section-title-line" />
              </div>
              <div className="video-wrap">
                <video controls width="100%">
                  <source src={professor.video_intro_url} type="video/mp4" />
                </video>
              </div>
            </div>
          )}

          {/* Avis */}
          <div className="detail-section">
            <div className="section-title">
              <MessageCircle size={18} style={{ verticalAlign: -3, marginRight: 8 }} />Avis des élèves
              <div className="section-title-line" />
              <span style={{ fontSize: 13, color: '#aaa', fontFamily: 'DM Sans', fontWeight: 400 }}>
                {reviews.length} avis
              </span>
            </div>

            {reviews.length === 0 ? (
              <div className="no-reviews-box">
                <div className="icon">📝</div>
                <p style={{ fontSize: 14 }}>Aucun avis pour le moment</p>
              </div>
            ) : (
              <>
                {reviews.map(r => (
                  <div key={r.id} className="review-card">
                    <div className="review-top">
                      <div className="reviewer-row">
                        <div className="reviewer-av">
                          {(r.eleve_nom || 'É').charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <div className="reviewer-name">{r.eleve_nom_anonyme || 'Élève vérifié'}</div>
                          <div className="review-date">{formatDate(r.created_at)}</div>
                        </div>
                      </div>
                      <Stars rating={r.rating} />
                    </div>
                    {r.commentaire && (
                      <p className="review-comment">« {r.commentaire} »</p>
                    )}
                    {(r.pedagogie_rating || r.communication_rating || r.ponctualite_rating) && (
                      <div className="review-sub-ratings">
                        {r.pedagogie_rating && <span className="sub-r-chip">Pédagogie {r.pedagogie_rating}/5</span>}
                        {r.communication_rating && <span className="sub-r-chip">Communication {r.communication_rating}/5</span>}
                        {r.ponctualite_rating && <span className="sub-r-chip">Ponctualité {r.ponctualite_rating}/5</span>}
                      </div>
                    )}
                  </div>
                ))}
                {hasMore && (
                  <button className="btn-more-reviews" onClick={loadMore}>
                    Voir plus d'avis
                  </button>
                )}
              </>
            )}
          </div>
        </div>

        {/* SIDEBAR */}
        <div className="detail-sidebar">

          {/* Card réservation */}
          <div className="sidebar-card">
            <div className="sidebar-card-header">
              {/* Prix masqué - tarif fixe FirstArabic */}
            </div>
            <div className="sidebar-card-body">
              <Link to={`/reservation?prof_id=${professor.id}`} className="btn-book-sidebar">
                <CalendarPlus size={18} style={{ verticalAlign: -3, marginRight: 8 }} />Réserver un cours
              </Link>
              <div className="sidebar-guarantee">
                🔒 Paiement sécurisé · Annulation flexible
              </div>
            </div>
          </div>

          {/* Card stats */}
          {stats && stats.rating_moyen > 0 && (
            <div className="sidebar-card">
              <div className="stats-card">
                <div className="section-title" style={{ fontSize: 14, marginBottom: 12 }}>
                  <BarChart3 size={18} style={{ verticalAlign: -3, marginRight: 8 }} />Notes détaillées
                </div>
                <div className="stat-row-card">
                  <span className="stat-row-label">Note globale</span>
                  <span className="stat-row-val">
                    <MiniStars rating={stats.rating_moyen} />
                    {stats.rating_moyen?.toFixed(1)}
                  </span>
                </div>
                {stats.rating_pedagogie > 0 && (
                  <div className="stat-row-card">
                    <span className="stat-row-label">Pédagogie</span>
                    <span className="stat-row-val">
                      <MiniStars rating={stats.rating_pedagogie} />
                      {stats.rating_pedagogie?.toFixed(1)}
                    </span>
                  </div>
                )}
                {stats.rating_communication > 0 && (
                  <div className="stat-row-card">
                    <span className="stat-row-label">Communication</span>
                    <span className="stat-row-val">
                      <MiniStars rating={stats.rating_communication} />
                      {stats.rating_communication?.toFixed(1)}
                    </span>
                  </div>
                )}
                {stats.rating_ponctualite > 0 && (
                  <div className="stat-row-card">
                    <span className="stat-row-label">Ponctualité</span>
                    <span className="stat-row-val">
                      <MiniStars rating={stats.rating_ponctualite} />
                      {stats.rating_ponctualite?.toFixed(1)}
                    </span>
                  </div>
                )}
                <div className="stat-row-card">
                  <span className="stat-row-label">Total avis</span>
                  <span className="stat-row-val">{professor.nombre_avis || 0} élèves</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* BOTTOM CTA MOBILE */}
      <div className="bottom-cta-bar">
        <div>
          <div className="bottom-cta-price">
            {'Sur demande'}
          </div>
          {/* Prix masqué */}
        </div>
        <Link to={`/reservation?prof_id=${professor.id}`} className="btn-book-bottom">
          Réserver
        </Link>
      </div>
    </div>
  );
}
